/** Mock referral payload until /api/referral is live. */



/**

 * Pipeline for a successful invite (left → right).

 * `expired` is a terminal side-state, not a step on the bar.

 */

export const INVITE_STATUS_STEPS = [

  { key: "invited", label: "Invited" },

  { key: "signed_up", label: "Signed up" },

  { key: "welcome_claimed", label: "Welcome gifts" },

  { key: "subscribed", label: "Subscribed" },

  { key: "rewarded", label: "Rewarded" },

];



export const INVITE_STATUS_ORDER = INVITE_STATUS_STEPS.map((s) => s.key);



export const INVITE_STATUS_META = {

  invited: { label: "Invited", tone: "muted" },

  signed_up: { label: "Signed up", tone: "info" },

  welcome_claimed: { label: "Welcome gifts", tone: "info" },

  subscribed: { label: "Subscribed", tone: "accent" },

  rewarded: { label: "Rewarded", tone: "success" },

  expired: { label: "Expired", tone: "warn" },

};



/** Map legacy mock keys if needed */

export function normalizeInviteStatus(status) {

  if (status === "shared") return "invited";

  return status;

}



export function getStatusStepIndex(status) {

  const key = normalizeInviteStatus(status);

  if (key === "expired") return -1;

  return INVITE_STATUS_ORDER.indexOf(key);

}



export const MOCK_REFERRAL_ME = {

  referral_code: "ABC12XYZ",

  plan_key: "pro",

  stats: {

    invited: 12,

    signed_up: 5,

    welcome_claimed: 4,

    subscribed: 3,

    rewarded: 3,

    /** Credits earned from referral payouts by period */
    credits_lifetime: 60,

    credits_year: 48,

    credits_month: 20,

  },

};



const avatar = (seed, name) =>

  `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(

    seed

  )}&backgroundColor=1a1a1a`;



export const MOCK_REFERRAL_INVITES = [

  {

    id: "1",

    friend_name: "Riya S.",

    friend_email: "riya@example.com",

    avatar_url: avatar("riya", "Riya S"),

    status: "rewarded",

    plan_label: "Lite",

    credits_earned: 6,

    date: "2026-09-02T14:32:00",

  },

  {

    id: "2",

    friend_name: "Amit K.",

    friend_email: "amit@example.com",

    avatar_url: avatar("amit", "Amit K"),

    status: "subscribed",

    plan_label: "Pro",

    credits_earned: null,

    date: "2026-09-07T09:15:00",

  },

  {

    id: "3",

    friend_name: "Sara M.",

    friend_email: "sara@example.com",

    avatar_url: avatar("sara", "Sara M"),

    status: "welcome_claimed",

    plan_label: null,

    credits_earned: null,

    date: "2026-09-08T18:41:00",

  },

  {

    id: "4",

    friend_name: "Dev P.",

    friend_email: "dev@example.com",

    avatar_url: avatar("dev", "Dev P"),

    status: "signed_up",

    plan_label: null,

    credits_earned: null,

    date: "2026-09-08T18:41:00",

  },

  {

    id: "5",

    friend_name: "Neha R.",

    friend_email: "neha@example.com",

    avatar_url: avatar("neha", "Neha R"),

    status: "invited",

    plan_label: null,

    credits_earned: null,

    date: "2026-09-08T18:41:00",

  },

  {

    id: "6",

    friend_name: "Karthik V.",

    friend_email: "karthik@example.com",

    avatar_url: avatar("karthik", "Karthik V"),

    status: "expired",

    plan_label: null,

    credits_earned: null,

    date: "2026-08-01T08:00:00",

  },

];


